import { useDecisionMakerResponsePageData } from 'src/app/pages/decisionMakerResponse/details/pageContext';

type Result = ModelHookResult<{
	respondUrl?: string;
	signUrl?: string;
	promoteUrl?: string;
}>;

export function useActions(): Result {
	const {
		data: {
			petitionSigned,
			decisionMakerResponse: {
				petition: { promotable, slug, viewerIsDecisionMaker, status },
			},
		},
	} = useDecisionMakerResponsePageData();

	const open = status === 'PUBLISHED';

	return {
		data: {
			respondUrl: viewerIsDecisionMaker ? `/p/${encodeURIComponent(slug)}/responses/new` : undefined,
			signUrl:
				open && !petitionSigned && !viewerIsDecisionMaker
					? `/p/${encodeURIComponent(slug)}?show_sign=true&source_location=decision_maker_response_page`
					: undefined,
			promoteUrl:
				open && petitionSigned && promotable && !viewerIsDecisionMaker
					? `/p/${encodeURIComponent(slug)}/psf/promote_or_share?source_location=decision_maker_response_page`
					: undefined,
		},
	};
}
